export const ArticleStatusEnum = {
  DELETE: -1,
  DRAFT: 0,
  PUBLISHED: 1,
}

export const useArticleStatusEnumText = () => {
  const enumToText = (status: number) => {
    switch (status) {
      case ArticleStatusEnum.DELETE:
        return '刪除'
      case ArticleStatusEnum.DRAFT:
        return '草稿'
      case ArticleStatusEnum.PUBLISHED:
        return '已發佈'
      default:
        return 'Unknown'
    }
  }

  return {
    enumToText,
  }
}

export const ArticleTypeEnum = {
  NEWS: 0,
  // 1:充電資訊
  CHARGING_INFO: 1,
}
